export const LogoutActionSelector = 'logoutAction';
export const RefreshActionSelector = 'refreshAction';
